import React from 'react';
import Layout from './Layout';
import { TextBadgeVariant } from './types';

export function TextBadge(props: {
  text: string,
  variant?: TextBadgeVariant,
  isSmall?: boolean,
  title?: string
}) {
  return <Layout {...props} />;
}
